<template>
  <div>
    <v-dialog
      v-model="showMachineLog"
      max-width="60%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          マイ機器ログ
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    日付
                  </th>
                  <th class="text-left">
                    履歴
                  </th>
                  <th class="text-left">
                    メモ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in machineLog"
                  :key="item.createdAt"
                  @click="showDetail(item)"
                  style="cursor: pointer;"
                >
                  <td>{{ item.createdAt| moment('YYYY[年]MM[月]DD[日] HH[時]mm[分]') }}</td>
                  <td>{{ getTypeText(item.Type) }}</td>
                  <td>{{ item.Description }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Detail表示ダイアログ -->
    <v-dialog
      v-model="showDetailDialog"
      max-width="70%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          機器ログ詳細
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols=3 dense class="font-weight-bold">日付</v-col>
            <v-col cols=9 dense>{{ selectedLog.createdAt | moment('YYYY[年]MM[月]DD[日] HH[時]mm[分]') }}</v-col>
            <v-col cols=3 dense class="font-weight-bold">履歴</v-col>
            <v-col cols=9 dense>{{ getTypeText(selectedLog.Type) }}</v-col>
            <v-col cols=3 dense class="font-weight-bold">メモ</v-col>
            <v-col cols=9 dense>{{ selectedLog.Description }}</v-col>
            <v-col cols=3 dense class="font-weight-bold">詳細</v-col>
            <v-col cols=9 dense>
              <pre style="white-space: pre-wrap; font-family: monospace; background-color: #f5f5f5; padding: 10px; border-radius: 4px;">{{ formatDetail(selectedLog.Detail) }}</pre>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="body-2 amber darken-1 font-weight-bold" @click="closeDetail()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-close</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { machineLogsByMachine } from '../graphql/queries'

export default {
  name: 'machineLog',
  data() {
    return {
      showMachineLog: false,
      machineLog: {},
      showDetailDialog: false,
      selectedLog: {},
    }
  },
  mounted: async function () {
  },
  computed : {
  },
  methods: {
    open: async function(id) {
      console.log("open machine Log", id)
      let machineLog = await API.graphql(graphqlOperation(machineLogsByMachine, {MachineID: id, sortDirection: 'DESC'}))
      this.machineLog = machineLog.data.machineLogsByMachine.items
      console.log("machineLog", machineLog)
      this.showMachineLog = true;
    },
    close() {
      this.showMachineLog = false;
    },
    showDetail(log) {
      this.selectedLog = log
      this.showDetailDialog = true
    },
    closeDetail() {
      this.showDetailDialog = false
      this.selectedLog = {}
    },
    getTypeText(type) {
      const typeMap = {
        'Update': '情報更新',
        'UsageTime': '使用時間',
        'UsageTime2': '使用時間2',
        'OilChange': 'Oil交換',
        'Mount': '換装',
        'Unmount': '取外',
        'Overhaul': 'ｵｰﾊﾞｰﾎｰﾙ'
      }
      return typeMap[type] || type
    },
    formatDetail(detail) {
      if (!detail) return ''
      try {
        const parsed = JSON.parse(detail)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return detail
      }
    }
  },
}
</script>